import { invoicePaymentBadge } from "../lib/commercial-status";

type InvoicePaymentBadgeProps = {
  invoice: { status: string; totalCents: number; balanceDueCents: number; paidCents?: number | null };
  className?: string;
  unpaidLabel?: string;
};

const money = (cents: number) => new Intl.NumberFormat(undefined, {
  style: "currency",
  currency: "USD",
}).format(cents / 100);

export function InvoicePaymentBadge({ invoice, className = "", unpaidLabel = "Unpaid" }: InvoicePaymentBadgeProps) {
  const badge = invoicePaymentBadge(invoice);
  if (!badge) return null;
  const content = badge.kind === "paid" ? `Paid · ${money(badge.amountCents)}`
    : badge.kind === "partially_paid" ? `Partially paid · ${money(badge.amountCents)} due`
    : badge.kind === "unpaid" ? `${unpaidLabel} · ${money(badge.amountCents)}`
    : badge.kind === "void" ? "Void"
    : "No charge";
  const tone = badge.kind === "paid" ? "bg-emerald-50 text-emerald-800"
    : badge.kind === "void" || badge.kind === "no_charge" ? "bg-slate-100 text-slate-700"
    : "bg-amber-50";
  return <span className={`rounded-full px-3 py-1 font-semibold ${tone} ${className}`}>{content}</span>;
}
